import { PROFILE_INFO_GRID_CLASS_NAME } from '../../constants/grid';

const profileInfoGrid = ({ theme }) => ({
  border: '1px solid',
  borderColor: theme.palette.divider,
  borderRadius: 12,
  padding: 24,
});

const MuiGrid = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${PROFILE_INFO_GRID_CLASS_NAME}`]: profileInfoGrid({ theme }),
    }),
  },
};

export default MuiGrid;
